module.exports = __webpack_public_path__ + "assets/img/axios_put.81d03f72.jpg";